import { render, staticRenderFns } from "./CartResume.vue?vue&type=template&id=6df2ca73&"
import script from "./CartResume.vue?vue&type=script&lang=js&"
export * from "./CartResume.vue?vue&type=script&lang=js&"
import style0 from "./CartResume.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports